import makeCrud from './crud'
export default makeCrud('localization_tax')
